export const checkIsNumber = (value: string | number) => {
  if (typeof value === 'number') return true

  return !isNaN(parseInt(value)) && String(parseInt(value)).length === value.length
}
